"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryPerformanceReportSchema = exports.CategoryTrendSchema = exports.CategoryTrendPointSchema = exports.CategoryPerformanceRowSchema = void 0;
const zod_1 = require("zod");
exports.CategoryPerformanceRowSchema = zod_1.z.object({
    categoryId: zod_1.z.string(),
    categoryName: zod_1.z.string(),
    revenue: zod_1.z.number(),
    cost: zod_1.z.number(),
    grossProfit: zod_1.z.number(),
    marginPct: zod_1.z.number(),
    units: zod_1.z.number(),
    transactions: zod_1.z.number(),
    growthPct: zod_1.z.number().optional(),
    rank: zod_1.z.number().optional(),
});
exports.CategoryTrendPointSchema = zod_1.z.object({
    date: zod_1.z.string(),
    revenue: zod_1.z.number(),
});
exports.CategoryTrendSchema = zod_1.z.object({
    categoryId: zod_1.z.string(),
    categoryName: zod_1.z.string(),
    points: zod_1.z.array(exports.CategoryTrendPointSchema),
});
exports.CategoryPerformanceReportSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    totalRevenue: zod_1.z.number(),
    totalUnits: zod_1.z.number(),
    activeCategories: zod_1.z.number(),
    topPerformer: exports.CategoryPerformanceRowSchema.optional(),
    worstPerformer: exports.CategoryPerformanceRowSchema.optional(),
    bestMarginCategory: exports.CategoryPerformanceRowSchema.optional(),
    worstMarginCategory: exports.CategoryPerformanceRowSchema.optional(),
    categories: zod_1.z.array(exports.CategoryPerformanceRowSchema),
    trendByCategory: zod_1.z.array(exports.CategoryTrendSchema),
});
//# sourceMappingURL=category-performance.schema.js.map